import type { Theme } from '@mui/material/styles';

/**
 * The primary brand gradient — used on hero CTAs, badges, and avatar icons
 * across the auth/landing pages. Resolves at render time from the active
 * theme's primary tokens, so a per-facility theme switch automatically
 * repaints every gradient that uses this helper.
 *
 * Usage:
 *   sx={(theme) => ({ background: brandGradient(theme) })}
 */
export const brandGradient = (theme: Theme) =>
  `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`;
